import { useQuery } from 'react-query';

import setupIntents from 'api/payment/setupIntents';

import { QUERY_IDS } from 'api';

const { SETUP_INTENTS } = QUERY_IDS;

const useSetupIntents = ({ listingId }) => {
  const { data, isFetching, isLoading, isSuccess, isError } = useQuery(SETUP_INTENTS, () => setupIntents(listingId), {
    refetchOnWindowFocus: false,
    refetch: false,
  });

  return {
    data,
    isFetching,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useSetupIntents;
